import { apiRoutes } from "@constants/api-routes";
import { AXN_COMPANY_ID_PATTERN } from "@constants/url-parameter-patterns";
import { RequestTypes } from "@enums/request-types";
import { OrganizationConfig } from "@idw-types/data/organization-config";
import { GenericNetworkResponse } from "@idw-types/generic-network-response";
import { handleRequest } from "@utils/http-util";
import { injectCustomIdParameter } from "@utils/parameter-injector";

export const getOrganizationConfig = async (
    axnCompanyId: string
): Promise<GenericNetworkResponse<OrganizationConfig>> => {
    const route = injectCustomIdParameter(apiRoutes.axnadminCore.organizationConfigWithId, axnCompanyId, AXN_COMPANY_ID_PATTERN);
    const { data, error } = await handleRequest(RequestTypes.GET, route);
    return { data, error };
};